<template>
    <div class="table-outer-box">
        <p>
            账　　号:{{ list.uName }}
            <el-image class="img" :src="require('../assets/img/edit.png')" v-show="this.$store.state.rank[1].Rank == 1"
                @click="linkToEdit(list)"></el-image>
            <el-image class="img" :src="require('../assets/img/resetPassword.png')" @click="resetPwd(list)"></el-image>

            <el-image class="img" :src="require('../assets/img/unlock.png')" v-if="list.uLock == 'False' ? true : false"
                @click="clickLock(list)"></el-image>
            <el-image class="img" :src="require('../assets/img/lock.png')" v-if="list.uLock == 'False' ? false : true"
                @click="clickLock(list)"></el-image>
        </p>
        <ul>
            <li v-for="item in titleList">
                <span style="color: black;">
                    {{ item.label }}:
                </span>
                <span>
                    {{ list[item.val] }}
                </span>

            </li>
        </ul>
    </div>

</template>
<script type="text/ecmascript-6">
import { Toast, MessageBox } from 'mint-ui';
import { resetPassword, userLock } from "../api/userMG";
export default {
    props: {
        list: Object,
        titleList: Array
    },
    data() {
        return {

        }
    },
    created() {
    },
    methods: {
        linkToEdit(val) {
            this.$router.push({
                name: "addAccount",
                params: {
                    type: '编辑',
                    val: val
                }
            });
        },
        // 重置密码
        resetPwd(list) {
            let that = this;
            let params = {
                companyid: that.$store.state.companyUser,
                userID: list.uName,
            };
            MessageBox.confirm('确定要重置密码吗?').then(action => {
                if (action) {
                    resetPassword(params).then((res) => {
                        Toast({
                            message: res.data.message,
                            position: 'middle',
                            duration: 2000
                        });
                    });
                }
            });
        },
        // 锁定用户
        clickLock(list) {
            let that = this;
            if (list.uLock == 'True') {
                MessageBox.confirm('确定要解除当前用户[' + list.uName + ']吗?').then(action => {
                    console.log(action)
                    if (action) {
                        let params = {
                            companyid: that.$store.state.companyUser,
                            type: 0,
                            UID: list.uName
                        };
                        userLock(params).then((res) => {
                            if (res.data.code == 100) {
                                that.$emit('init', 'reload')
                            }
                            Toast({
                                message: res.data.message,
                                position: 'middle',
                                duration: 2000
                            });
                        });
                    }
                });
            } else {
                MessageBox.confirm('确定要锁定当前用户[' + list.uName + ']吗?').then(action => {
                    if (action) {
                        let params = {
                            companyid: that.$store.state.companyUser,
                            type: 1,
                            UID: list.uName
                        };
                        userLock(params).then((res) => {
                            if (res.data.code == 100) {
                                that.$emit('init', 'reload')
                            }
                            Toast({
                                message: res.data.message,
                                position: 'middle',
                                duration: 2000
                            });
                        });
                    }
                });

            }

        }
    }
}

</script>
<style scoped lang="less">
.table-outer-box {
    display: flex;
    flex-direction: column;
    flex: 1;

    p {
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        text-indent: 10px;
        padding: 5px 0;
        border-bottom: 1px solid #D3D3D3;
        background: #6495ED;
        color: white;

        .img {
            width: 20px;
            height: 20px;
            float: right;
            margin-right: 15px;
            overflow: visible;
        }
    }


    ul {
        width: 100%;
        overflow: hidden;
        padding: 0 5px;

        li {
            width: 48%;
            height: 17px;
            float: left;
            text-decoration: none;
            margin: 2px 0;

            span {
                display: inline-block;
                height: 17px;
                line-height: 17px;
            }

            span:last-child {
                color: #808080;
                display: inline-block;
                white-space: nowrap;
                /*强制单行显示*/
                text-overflow: ellipsis;
                /*文本超出部分省略号表示*/
                overflow: hidden;
                /*文本超出部分隐藏*/
                width: 62%;
                /*设置文本显示的最大宽度*/
                display: inline-block
                    /*设为行内块元素*/
                ;
                vertical-align: top
            }
        }

        li::marker {
            content: "";
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/accontTable.vue